<template>
  <v-container fill-height fluid class="pa-0">
    <v-row no-gutters class="fill-height">
      <v-col>
        <iframe :src="iframeUrl" width="100%" height="100%" style="border: none"></iframe>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'IframeLayout',
  props: {
    iframeUrl: {
      type: String,
      required: true,
    },
  },
};
</script>
